<template>
  <div class="selectel-uploader">
    <input v-model="fileLink" type="text" class="form-control" placeholder="Place link to selectel" @blur="checkLink">

    <div class="file-uploader__folder">
      <i class="fa fa-folder-open" @click="showSelectelList = !showSelectelList" />
      <div v-if="showSelectelList" class="file-uploader__list-popup spinner-parent">
        <spinner v-if="selectelLoading" size="md" text="Loading ..." style="display: block;" />
        <div v-else class="file-uploader__list">
          <ul v-if="selectelList">
            <FileUploaderFolder
              v-for="(folder, name) in selectelList.folders"
              :key="name"
              :name="name"
              :content="folder"
              @attach-file="attachFile"
            />
            <File v-for="file in selectelList.files" :key="file.basename" @attach-file="attachFile" />
          </ul>
          <div v-else>Container is empty</div>
        </div>
      </div>
    </div>

    <div v-if="fileLink && linkStatus" class="file-uploader__check">
      <div v-if="linkStatus === 'loading'" class="check-status check-loader" title="Link is checking...">
        <i class="fa fa-spinner" />
      </div>
      <div v-if="linkStatus === 'ok'" class="check-status check-ok" title="Link is correct">
        <i class="fa fa-check" />
      </div>
      <div v-if="linkStatus === 'error'" class="check-status check-error" title="Link is incorrect">
        <i class="fa fa-times" />
      </div>
    </div>
  </div>
</template>

<script>
import File from './File';

export default {
  name: 'SelectelUploader',
  components: {
    File,
  },
  props: {
    fileLink: {
      type: String,
      default: '',
    },
    selectelList: {
      type: Object,
      default: null,
    },
    linkStatus: {
      type: String,
      default: '',
    },
    selectelLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showSelectelList: false,
  }),
  methods: {
    attachFile(url) {
      this.$emit('file-attached', url);
      this.showSelectelList = false;
    },
    checkLink() {
      this.$emit('blur');
    },
  },
};
</script>

<style>
  .selectel-uploader {
    position: relative;
    width: 100%;
  }
  .file-uploader__quality-label {
    margin-bottom: 5px;
  }

  .file-uploader__check {
    position: absolute;
    top: 0;
    right: 30px;
  }
  .check-status {
    height: 35px;
    width: 35px;
    line-height: 35px;
    text-align: center;
    font-size: 20px;
  }
  .check-ok { color: green; }
  .check-error { color: red; }
  .check-loader i {
    animation: spin 0.6s linear;
    animation-iteration-count: infinite;
  }

  .file-uploader__folder {
    position: absolute;
    top: 0;
    right: 0;
    height: 35px;
    width: 35px;
    line-height: 35px;
    text-align: center;
  }
  .file-uploader__folder > i {
    font-size: 18px;
    cursor: pointer;
  }

  .file-uploader__list-popup {
    position: absolute;
    top: 0;
    right: 40px;
    z-index: 25;
    width: 400px;
    max-height: 350px;
    padding: 20px;
    border: 1px solid #cfd8dc;
    background: #ffffff;
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.2);
    font-size: 16px;
  }
  .file-uploader__list-popup:after,
  .file-uploader__list-popup:before {
    content: '';
    position: absolute;
    top: 10px;
    left: 100%;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-left: 10px solid #cfd8dc;
    border-bottom: 6px solid transparent;
  }
  .file-uploader__list-popup:before {
    left: calc(100% - 2px);
    z-index: 100;
    border-left: 10px solid #fff;
  }
  .file-uploader__list {
    max-height: 310px;
    overflow: auto;
  }
  .file-uploader__list ul {
    margin-bottom: 0;
    padding-left: 0;
  }

  .file-uploader__list ul ul {
    padding-left: 20px;
  }
  .file-uploader__list ul li {
    margin-bottom: 10px;
    line-height: 20px;
    text-align: left;
    list-style-type: none;
  }
  .file-uploader__list ul li:last-child {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// SelectelUploader.vue?0d28f61d